import React from 'react';
import { Link } from 'react-router-dom';
import { LocalCitySeo } from '../data/localSeoContent';

type Props = {
  content: LocalCitySeo;
};

/** Compact local SEO block — place below plan cards so packages stay above the fold on mobile. */
const LocalCitySeoBlock: React.FC<Props> = ({ content }) => {
  const serviceLabel = content.service === 'internet' ? 'Internet' : 'Phone Service';

  return (
    <section
      className="py-12 md:py-16 bg-[#0a0f1a] border-t border-white/10"
      aria-labelledby="local-seo-heading"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 id="local-seo-heading" className="text-2xl md:text-3xl font-bold text-white mb-3">
          {content.headline}
        </h2>
        <p className="text-base md:text-lg text-white/65 max-w-3xl leading-relaxed mb-8">
          {content.intro[0]}
        </p>

        <div className="grid sm:grid-cols-2 gap-8">
          <div>
            <h3 className="text-lg font-bold text-white mb-3">Serving {content.city}</h3>
            <ul className="space-y-2 text-sm md:text-base text-white/65">
              {content.areas.slice(0, 3).map((area) => (
                <li key={area} className="flex gap-2">
                  <span className="text-blue-400 mt-1">•</span>
                  <span>{area}</span>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-bold text-white mb-3">Why Airmax</h3>
            <ul className="space-y-2 text-sm md:text-base text-white/65">
              {content.whyLocal.slice(0, 3).map((item) => (
                <li key={item} className="flex gap-2">
                  <span className="text-blue-400 mt-1">•</span>
                  <span>{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <nav className="mt-8 pt-6 border-t border-white/10" aria-label={`${content.city} related pages`}>
          <p className="text-sm font-semibold text-white mb-2">
            More {serviceLabel.toLowerCase()} in our area
          </p>
          <ul className="flex flex-wrap gap-x-5 gap-y-2">
            {content.relatedLinks.map((link) => (
              <li key={link.href}>
                <Link
                  to={link.href}
                  onClick={() => window.scrollTo(0, 0)}
                  className="text-blue-400 hover:underline text-sm font-medium"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </section>
  );
};

export default LocalCitySeoBlock;
